export default __webpack_public_path__ + "static/media/NEW_LABEL_CONFIRMED.af092511.svg";